import { createFeatureSelector } from '@ngrx/store';

import { SHOP_THE_LOOK_FEATURE_KEY } from './constants';
import { State } from './main-reducer';
export const selectShopTheLookState = createFeatureSelector<State>(
  SHOP_THE_LOOK_FEATURE_KEY,
);
